import React from 'react';
import { DashboardLayout } from '@/components/layouts/DashboardLayout';
import { ArrowRight, MoreHorizontal, DollarSign } from 'lucide-react';

const pipelineStages = [
  { 
    name: "Prosperación", 
    color: "bg-ink",
    items: [
      { id: "1", title: "Depto Vitacura", client: "Juan Pérez", value: "12.500 UF" },
      { id: "2", title: "Casa Las Condes", client: "María Soto", value: "24.000 UF" }
    ]
  },
  { 
    name: "Visita", 
    color: "bg-terracotta",
    items: [
      { id: "3", title: "Oficina Providencia", client: "Inversiones S.A.", value: "8.200 UF" }
    ]
  },
  { 
    name: "Oferta", 
    color: "bg-moss",
    items: [
      { id: "4", title: "Parcela Chicureo", client: "Familia Rossi", value: "15.900 UF" }
    ]
  },
  { 
    name: "Cierre", 
    color: "bg-ink",
    items: []
  }
];

export function CRMPipelinePage() {
  return (
    <DashboardLayout>
      <div className="space-y-8">
        <div>
          <h1 className="text-4xl font-display font-black uppercase text-ink italic">Pipeline de Operaciones</h1>
          <p className="text-serif italic text-ink/60 mt-2">Visualiza y gestiona el flujo de tus ventas y arriendos.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pipelineStages.map((stage, idx) => (
            <div key={idx} className="space-y-6">
              <div className="flex items-baseline justify-between border-b-2 border-ink pb-4">
                <h3 className="font-display font-black uppercase italic text-sm tracking-widest flex items-center gap-2">
                  <div className={`w-3 h-3 ${stage.color}`} />
                  {stage.name}
                </h3>
                <span className="text-xs font-black opacity-30">{stage.items.length}</span>
              </div>

              <div className="space-y-4">
                {stage.items.map((item) => (
                  <div key={item.id} className="brutalist-border bg-parchment p-4 hover:-translate-y-1 transition-transform cursor-pointer group">
                    <div className="flex justify-between items-start mb-4">
                      <h4 className="text-sm font-display font-black uppercase italic group-hover:text-terracotta transition-colors">{item.title}</h4>
                      <button className="text-ink/20"><MoreHorizontal className="h-4 w-4" /></button>
                    </div>
                    <p className="text-[10px] font-serif italic text-ink/60 mb-4">{item.client}</p>
                    <div className="flex justify-between items-center pt-4 border-t border-ink/5">
                      <div className="flex items-center text-xs font-black text-terracotta">
                        <DollarSign className="h-3 w-3" />
                        {item.value}
                      </div>
                      <ArrowRight className="h-4 w-4 text-ink/20 group-hover:text-terracotta transition-colors" />
                    </div>
                  </div>
                ))}
                
                {stage.items.length === 0 && (
                  <div className="h-24 border-2 border-dashed border-ink/10 flex items-center justify-center text-[10px] font-black uppercase tracking-widest text-ink/20">
                    Sin operaciones
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
}
